var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"encart-la-formation"},[_vm._m(0),_vm._v(" "),_c('KookBtn',{staticClass:"--angle-right --bg-white --font-orange",attrs:{"texte":"Je trouve ma formation","url":"https://www.greta-cfa-paysdelaloire.fr/nos-formations/","blank":true}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"title"},[_c('span',{staticClass:"first-line"},[_vm._v("Trouvez LA")]),_vm._v(" "),_c('span',{staticClass:"second-line"},[_vm._v("Formation faite pour vous")])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/sidebar/EncartLaFormation.vue